import { Children } from "react";
import { Navigate, Route } from "react-router-dom";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";

import { useContextViews } from "src/Contexts/Views/contextViews";
import { BreadcrumbsCore } from "src/Pages/components/BreadcrumbsCore/BreadcrumbsCore";
import { ModalFirstConfig } from "src/Pages/components/ModalFirstConfig/ModalFirstConfig";
import { UrlConfig } from "src/shared/Utils/paths";

export const PrivateRoutes = () => {
  const { ...routesAll } = useContextViews();
  const { authorization } = useAuthContext();

  return (
    <>
      {Object.values(routesAll).map((arrayValues) => {
        return Children.toArray(
          arrayValues.map((routes) => {
            return (
              routes.isView && (
                <Route
                  element={
                    <>
                      <BreadcrumbsCore
                        data={[
                          {
                            title: routes.route.title,
                            subsTitle: routes.route.subsTitle,
                            to: routes.route.url,
                          },
                        ]}
                      />
                      <ModalFirstConfig />
                      {routes.element}
                    </>
                  }
                  path={routes.route.url}
                />
              )
            );
          })
        );
      })}
      {authorization && (
        <Route element={<Navigate to={UrlConfig.dashboard.url} />} path="*" />
      )}
    </>
  );
};
